export {
  getEventTarget,
  getPropagationTargets,
  nodeContains,
  isFocusWithin,
  getActiveElement
} from '../../../../src/utils/shadowdom/DOMFunctions';
